import { render } from "./RockHeaderWallet.vue?vue&type=template&id=0eedec52&scoped=true"
import script from "./RockHeaderWallet.vue?vue&type=script&lang=js"
export * from "./RockHeaderWallet.vue?vue&type=script&lang=js"

import "./RockHeaderWallet.vue?vue&type=style&index=0&id=0eedec52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eedec52"]])

export default __exports__